#!/usr/bin/env node

import { forcePullAllPublishedTranslations } from './pull-client';

await forcePullAllPublishedTranslations();
